export const getStatusColor = (s) => {
  const map = {
    New: "primary",
    Contacted: "info",
    Qualified: "success",
    Connected: "warning",
    Lost: "error",
    "Follow up": "secondary",
    Chatting: "info",
    Select: "default",
    Meeting: "warning",
  };
  return map[s] || "default";
};

export const formatFileName = (file, index) => {
  return file?.title || file?.file_name || file?.name || `File ${index + 1}`;
};

export const formatFileType = (file, filePath) => {
  return (
    file?.type ||
    file?.mime_type ||
    filePath?.split(".").pop()
  )?.toUpperCase();
};

/** Eager-loaded relations for GET /leads — only what the list table renders */
export const LEADS_LIST_RELATIONS = [
  "assignees",
  "author",
  "lastStatusLog",
  "lastStatusLog.status",
  "attachments",
  "meetings",
  "issue",
  "orders.orderServices.service",
  "orders.attachments",
  "brand",
  // 'invoices.hasPayments'
];

/** Relations for GET /leads/:id (edit / view form hydration) */
export const LEAD_DETAIL_RELATIONS = [
  ...LEADS_LIST_RELATIONS,
  "source",
  "country",
  "dba",
  "brand",
  "company",
  "legalInformation",
  "merchant",
  "bankAccount",
  "equipments",
  "orders",
];

export function buildLeadDetailParams() {
  return { "relations[]": LEAD_DETAIL_RELATIONS };
}

/**
 * Params for lead pickers (e.g. call recordings).
 * No relations: options only need the lead's own name / dba_name / email / phone,
 * so eager-loading the list relations here is wasted work on every dropdown open.
 */
export function buildLeadsAutocompleteParams({
  search = "",
  page = 1,
  perPage = 100,
  sortBy = "updated_at",
  sortDirection = "desc",
} = {}) {
  const term = typeof search === "string" ? search.trim() : "";
  return {
    paginate: 1,
    page,
    per_page: perPage,
    sort_by: sortBy,
    sort_direction: sortDirection,
    ...(term ? { search: term } : {}),
  };
}

export const buildQueryParams = (
  pagination,
  filters,
  sort,
  noActivity,
  searchValue,
) => {
  const params = {
    "relations[]": LEADS_LIST_RELATIONS,
    paginate: 1,
    page: pagination.page + 1,
    per_page: pagination.pageSize,
    ...(searchValue && { search: searchValue }),
  };

  if (filters.status_id && filters.status_id !== "") {
    params["status_id"] = filters.status_id;
  }

  if (filters.payment_status && filters.payment_status !== "") {
    params.payment_status = filters.payment_status;
  }

  // Keep other filters with filters[] prefix (if needed)
  const otherFilters = { ...filters };
  delete otherFilters.status_id;
  delete otherFilters.payment_status;

  Object.entries(otherFilters).forEach(([key, value]) => {
    if (value && value !== "") {
      params[`filters[${key}]`] = value;
    }
  });

  if (sort.sort_by) params["sort_by"] = sort.sort_by;
  if (sort.sort_direction) params["sort_direction"] = sort.sort_direction;
  if (noActivity.no_activity_since_days) {
    params["no_activity_since_days"] = noActivity.no_activity_since_days;
  }

  return params;
};
